$(document).ready(function() {
    $('#TotemForm_EditCustomerForm_CountryGeoID').change(function() {
        var val = this.value;
        $.ajax({
            url: '/affiliate/statesjson',
            data: {
                country: val
            },
            type: 'GET',
            success: function(data) {
                var responseJSON = jQuery.parseJSON(data);
                $('#TotemForm_EditCustomerForm_StateGeoID').html(responseJSON.html);
            },
            error: function(data) {}
        });
    });

    var theModal = $('#CurrentCommission');
    if (theModal.length) {
        theModal.modal({ backdrop: false });
        theModal.show();
    }
    $('#TotemForm_EditCustomerForm_action_EditAffiliate').on('click', (e) => {
        e.preventDefault();
        window.location = $('#TotemForm_EditCustomerForm_action_EditAffiliate').attr('href')
    })

    $('#TotemForm_EditCustomerForm_HasBeenFinalised')
        .change(function() {
            var el = $('#FinalisedDate');
            if ($(this).is(':checked')) {
                el.show();
            } else {
                el.hide();
            }
        })
        .trigger('change');

    $('#TotemForm_EditCustomerForm_HasBeenInterviewed')
        .change(function() {
            var el = $('#InterviewDate');
            if ($(this).is(':checked')) {
                el.show();
            } else {
                el.hide();
            }
        })
        .trigger('change');

    $('#TotemForm_EditCustomerForm_HasBeenApproved')
        .change(function() {
            var el = $('#ApprovalDate');
            if ($(this).is(':checked')) {
                el.show();
            } else {
                el.hide();
            }
        })
        .trigger('change');

    $('#TotemForm_EditCustomerForm_HasReferralBeenPaid')
        .change(function() {
            var el = $('#ReferralPaidDate');
            if ($(this).is(':checked')) {
                el.show();
            } else {
                el.hide();
            }
        })
        .trigger('change');
});
